import { useEffect, useState } from 'react'

import type { TimeLeftT } from './TimeBox'

export const useTimeBox = (end: Date, formular: ValueOf<ClockType>['formular']) => {
  const [time, setTime] = useState<TimeLeftT['days']>()

  useEffect(() => {
    const setCountDown = setInterval(() => {
      const difference = +end - +new Date()

      if (difference > 0) {
        const timeLeft = Math.floor(formular(difference))

        if (time !== timeLeft) {
          setTime(timeLeft)
        }
      }
    }, 1000)
    return () => {
      clearInterval(setCountDown)
    }
  }, [end])

  return time
}

export type ClockType = Record<
  'timeOne' | 'timeTwo' | 'timeThree',
  {
    color: string
    formular: (diff: number) => number
    kor: '일' | '시' | '분' | '초'
  }
>

export const clock: ClockType = {
  timeOne: { color: 'transparent', formular: (diff) => diff / (1000 * 60 * 60 * 24), kor: '일' },
  timeTwo: { color: 'transparent', formular: (diff) => (diff / (1000 * 60 * 60)) % 24, kor: '시' },
  timeThree: { color: 'transparent', formular: (diff) => (diff / 1000 / 60) % 60, kor: '분' },
}

export const lastDayClock: ClockType = {
  timeOne: { color: 'transparent', formular: (diff) => (diff / (1000 * 60 * 60)) % 24, kor: '시' },
  timeTwo: { color: 'transparent', formular: (diff) => (diff / 1000 / 60) % 60, kor: '분' },
  timeThree: { color: 'transparent', formular: (diff) => (diff / 1000) % 60, kor: '초' },
}
